module.exports = __webpack_public_path__ + "static/img/OrganizationC240129TW.5ca1acd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OrganizationC240129TW.jpg
// module id = ADJC
// module chunks = 1